export const SET_NST_BALANCE = 'SET_NST_BALANCE';
export const SET_NUC_BALANCE = 'SET_NUC_BALANCE';